import { render, staticRenderFns } from "./BundleEditor.vue?vue&type=template&id=259ee8fa&"
import script from "./BundleEditor.vue?vue&type=script&lang=js&"
export * from "./BundleEditor.vue?vue&type=script&lang=js&"
import style0 from "./BundleEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('259ee8fa')) {
      api.createRecord('259ee8fa', component.options)
    } else {
      api.reload('259ee8fa', component.options)
    }
    module.hot.accept("./BundleEditor.vue?vue&type=template&id=259ee8fa&", function () {
      api.rerender('259ee8fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/BundleEditor.vue"
export default component.exports